{
  "REPORT": {
    "HEADER": "Samtaler",
    "LOADING_CHART": "Indlæser diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke modtaget nok datapunkter til at generere rapport. Prøv igen senere.",
    "DOWNLOAD_AGENT_REPORTS": "Download agentrapporter",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Indkommende Beskeder",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Udgående beskeder",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Første Respons Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Første svartid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsnings Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Opløsningstid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal Afsluttede",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Antal Afsluttede",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "I dag",
      "YESTERDAY": "I går",
      "LAST_7_DAYS": "Seneste 7 dage",
      "LAST_30_DAYS": "Seneste 30 dage",
      "THIS_MONTH": "Denne måned",
      "LAST_MONTH": "Sidste måned",
      "LAST_3_MONTHS": "Seneste 3 måneder",
      "LAST_6_MONTHS": "Seneste 6 måneder",
      "LAST_YEAR": "Sidste år",
      "CUSTOM_DATE_RANGE": "Tilpasset datointerval"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Anvend",
      "PLACEHOLDER": "Vælg datointerval"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Gruppér Efter",
    "DURATION_FILTER_LABEL": "Varighed",
    "GROUPING_OPTIONS": {
      "DAY": "Dag",
      "WEEK": "Uge",
      "MONTH": "Måned",
      "YEAR": "År"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dag"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dag"
      },
      {
        "id": 2,
        "groupBy": "Uge"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dag"
      },
      {
        "id": 2,
        "groupBy": "Uge"
      },
      {
        "id": 3,
        "groupBy": "Måned"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dag"
      },
      {
        "id": 2,
        "groupBy": "Uge"
      },
      {
        "id": 3,
        "groupBy": "Måned"
      }
    ],
    "BUSINESS_HOURS": "Forretningstider",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ingen resultater fundet"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Samtaler: {count}",
      "RESULT_COUNT_MESSAGE": "Beskeder: {count}",
      "EMPTY": "Ingen poster fundet for denne søjle.",
      "ERROR": "Posterne kunne ikke indlæses. Prøv igen.",
      "LOAD_MORE": "Indlæs flere",
      "PREVIOUS_BUCKET": "Forrige søjle",
      "NEXT_BUCKET": "Næste søjle",
      "UNKNOWN_CONTACT": "Ukendt kontakt",
      "UNKNOWN_INBOX": "Ukendt indbakke",
      "UNASSIGNED_AGENT": "Ikke tildelt",
      "NO_MESSAGE_CONTENT": "Intet beskedindhold",
      "MESSAGE_CREATED_AT": "Besked oprettet {time}",
      "EVENT_OCCURRED_AT": "Hændelse fandt sted {time}",
      "INCOMING_MESSAGE": "Indgående besked",
      "OUTGOING_MESSAGE": "Udgående besked",
      "VIEW_ALL": "Vis i samtaler",
      "VIEW_ALL_LIMIT": "Kun søjler med højst {limit} samtaler kan åbnes i samtalelisten.",
      "HIDDEN_COUNT": "Ikke vist, fordi du ikke er medlem af deres indbakke: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agenter Oversigt",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Indlæser diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke modtaget nok datapunkter til at generere rapport. Prøv igen senere.",
    "DOWNLOAD_AGENT_REPORTS": "Download agentrapporter",
    "FILTER_DROPDOWN_LABEL": "Vælg Agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Indkommende Beskeder",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Udgående beskeder",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Første Respons Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Første svartid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsnings Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Opløsningstid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal Afsluttede",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Seneste 7 dage"
      },
      {
        "id": 1,
        "name": "Seneste 30 dage"
      },
      {
        "id": 2,
        "name": "Seneste 3 måneder"
      },
      {
        "id": 3,
        "name": "Seneste 6 måneder"
      },
      {
        "id": 4,
        "name": "Sidste år"
      },
      {
        "id": 5,
        "name": "Tilpasset datointerval"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Anvend",
      "PLACEHOLDER": "Vælg datointerval"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Oversigt Over Etiketter",
    "DESCRIPTION": "Følg etiketternes præstation med nøgletal som samtaler, svartider, løsningstider og løste sager.",
    "LOADING_CHART": "Indlæser diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke modtaget nok datapunkter til at generere rapport. Prøv igen senere.",
    "DOWNLOAD_LABEL_REPORTS": "Download etiketrapporter",
    "FILTER_DROPDOWN_LABEL": "Vælg Etiket",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Indkommende Beskeder",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Udgående beskeder",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Første Respons Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Første svartid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsnings Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Opløsningstid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal Afsluttede",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Seneste 7 dage"
      },
      {
        "id": 1,
        "name": "Seneste 30 dage"
      },
      {
        "id": 2,
        "name": "Seneste 3 måneder"
      },
      {
        "id": 3,
        "name": "Seneste 6 måneder"
      },
      {
        "id": 4,
        "name": "Sidste år"
      },
      {
        "id": 5,
        "name": "Tilpasset datointerval"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Anvend",
      "PLACEHOLDER": "Vælg datointerval"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Oversigt Over Indbakke",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Indlæser diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke modtaget nok datapunkter til at generere rapport. Prøv igen senere.",
    "DOWNLOAD_INBOX_REPORTS": "Download indbakke rapporter",
    "FILTER_DROPDOWN_LABEL": "Vælg Indbakke",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Indkommende Beskeder",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Udgående beskeder",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Første Respons Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Første svartid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsnings Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Opløsningstid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal Afsluttede",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Seneste 7 dage"
      },
      {
        "id": 1,
        "name": "Seneste 30 dage"
      },
      {
        "id": 2,
        "name": "Seneste 3 måneder"
      },
      {
        "id": 3,
        "name": "Seneste 6 måneder"
      },
      {
        "id": 4,
        "name": "Sidste år"
      },
      {
        "id": 5,
        "name": "Tilpasset datointerval"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Anvend",
      "PLACEHOLDER": "Vælg datointerval"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Oversigt",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Indlæser diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke modtaget nok datapunkter til at generere rapport. Prøv igen senere.",
    "DOWNLOAD_TEAM_REPORTS": "Download teamrapporter",
    "FILTER_DROPDOWN_LABEL": "Vælg Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Indkommende Beskeder",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Udgående beskeder",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Første Respons Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Første svartid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsnings Tid",
        "DESC": "( Gns. )",
        "INFO_TEXT": "Samlet antal samtaler, der anvendes til beregning:",
        "TOOLTIP_TEXT": "Opløsningstid er {metricValue} (baseret på {conversationCount} samtaler)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal Afsluttede",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Seneste 7 dage"
      },
      {
        "id": 1,
        "name": "Seneste 30 dage"
      },
      {
        "id": 2,
        "name": "Seneste 3 måneder"
      },
      {
        "id": 3,
        "name": "Seneste 6 måneder"
      },
      {
        "id": 4,
        "name": "Sidste år"
      },
      {
        "id": 5,
        "name": "Tilpasset datointerval"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Anvend",
      "PLACEHOLDER": "Vælg datointerval"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Rapporter",
    "NO_RECORDS": "Der er ingen CSAT undersøgelse svar til rådighed.",
    "DOWNLOAD": "Download CSAT Rapporter",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Vælg Agenter"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Tildelt agent",
        "RATING": "Bedømmelse",
        "FEEDBACK_TEXT": "Kommentar til feedback"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Svar i alt",
        "TOOLTIP": "Samlet antal indsamlede svar"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Tilfredshed score",
        "TOOLTIP": "Samlet antal positive respons / Samlet antal respons * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Respons rate",
        "TOOLTIP": "Samlet antal svar / Samlet antal CSAT undersøgelsesmeddelelser sendt * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Antal samtaler",
        "TOOLTIP": "Samlet antal samtaler med bot-beskeder"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Antal svar",
        "TOOLTIP": "Samlet antal udgående beskeder"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Antal AI-svar",
        "TOOLTIP": "Samlet antal svarbeskeder sendt af botten"
      },
      "COPILOT_COUNT": {
        "LABEL": "Antal forberedte svar",
        "TOOLTIP": "Samlet antal copilot-forslag forberedt af botten til agenter"
      },
      "SUCCESS_RATE": {
        "LABEL": "Løst af AI",
        "TOOLTIP": "Andel af samtaler løst af AI uden overdragelse til en agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Løsningstid",
        "TOOLTIP": "Median tid fra kundens første besked til sidste bot-/agentbesked"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Gruppér ikke",
      "INBOXES": "Indbakker",
      "LABELS": "Etiketter"
    },
    "GROUPED": {
      "CHART_TITLE": "Fordeling efter gruppe",
      "BACK_TO_ALL": "Vis alle",
      "TABLE": {
        "INBOX": "Indbakke",
        "LABEL": "Etiket",
        "CONVERSATIONS": "Samtaler",
        "MESSAGES": "Beskeder",
        "MESSAGES_TOOLTIP": "Samlet antal udgående beskeder",
        "AI_MESSAGES": "AI-svar",
        "AI_MESSAGES_TOOLTIP": "Samlet antal AI-svar, efterfulgt af antallet af positive og negative bedømmelser fra slutbrugere",
        "THUMBS_UP_TOOLTIP": "Antal AI-svar bedømt positivt (tommel op) af slutbrugere",
        "THUMBS_DOWN_TOOLTIP": "Antal AI-svar bedømt negativt (tommel ned) af slutbrugere",
        "PREPARED": "Forberedte svar",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Andel af beskeder ud af alle beskeder i denne gruppe",
        "BOT_RESPONSES": "AI-svar %",
        "SUGGESTION_USED": "Anvendte svar",
        "SUGGESTION_USED_TOOLTIP": "Andel af forberedte svar i denne gruppe, der blev brugt af agenter",
        "SUGGESTION_NOT_USED": "Ubrugte svar",
        "SUGGESTION_NOT_USED_TOOLTIP": "Andel af beskeder i denne gruppe, der havde et forberedt svar, som ikke blev brugt"
      },
      "NOTES": {
        "TITLE": "Sådan beregnes målingerne",
        "CONVERSATIONS": "Antal samtaler med mindst én udgående besked i den valgte periode.",
        "MESSAGES": "Samlet antal udgående (ikke-private) beskeder sendt i den valgte periode. Dette omfatter både AI-genererede og menneskeskrevne beskeder.",
        "PERCENTAGE": "Andel af denne gruppes beskeder ud af alle udgående beskeder i alle grupper.",
        "AI_MESSAGES": "Antal udgående beskeder sendt automatisk af AI-botten (uden forberedte svar til agenter). Tallene i parentes viser, hvor mange af disse svar der blev bedømt positivt (tommel op) og negativt (tommel ned) af slutbrugere.",
        "PREPARED": "Antal copilot-forslag (forberedte svar) genereret af AI-botten til agenter i den valgte periode. Disse er private beskeder, som kun agenter kan se, og de tælles ikke som udgående beskeder, så tallet stemmer muligvis ikke overens med kolonnen Beskeder.",
        "SUGGESTION_USED": "Andel af forberedte svar i denne gruppe, der blev brugt af agenter. Dette stemmer muligvis ikke overens med antallet af forberedte svar, da det også kan omfatte forslag genereret i tidligere perioder.",
        "SUGGESTION_NOT_USED": "Andel af udgående beskeder i denne gruppe, hvor der var et copilot-forslag tilgængeligt, men agenten svarede uden at bruge det. Dette tælles kun, når agenten faktisk sendte et svar. Dette stemmer muligvis ikke overens med antallet af forberedte svar, da det også kan omfatte forslag genereret i tidligere perioder."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Oversigt",
    "LIVE": "Levende",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Åbn Samtaler",
      "LOADING_MESSAGE": "Indlæser samtalemetrik...",
      "OPEN": "Åbn",
      "UNATTENDED": "Unattet",
      "UNASSIGNED": "Ikke Tildelt",
      "PENDING": "Afventer"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Samtaler af agenter",
      "LOADING_MESSAGE": "Indlæser agent målinger...",
      "NO_AGENTS": "Der er ingen samtaler af agenter",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Åbn",
        "UNATTENDED": "Unattet",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Åbn",
        "UNATTENDED": "Unattet",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agentens status",
      "ONLINE": "Online",
      "BUSY": "Optaget",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ingen resultater fundet",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agentens navn",
        "INBOXES": "Indbakkens navn",
        "LABELS": "Etiket Navn",
        "TEAMS": "Team navn"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Indbakke",
      "AGENTS": "Agent",
      "LABELS": "Etiketter",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Samtale",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotal",
    "NO_TEAM": "Intet team",
    "GROUP_BY_TEAMS": "Gruppér efter teams",
    "INBOX": "Indbakke",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Etiket",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Antal Afsluttede",
    "CONVERSATIONS": "Antal samtaler",
    "OUTGOING_CHATS": "Udgående chats",
    "OUTGOING_EMAILS": "Udgående e-mails",
    "PHONE_CALLS": "Telefonopkald",
    "INBOUND_CALLS": "Indgående opkald",
    "OUTBOUND_CALLS": "Udgående opkald",
    "TOTAL_ACTIVITIES": "Aktiviteter i alt",
    "ONLINE_TIME": "Online-tid",
    "QUEUE_AVAILABLE_TIME": "Tilgængelig tid i kø",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Antal udgående beskeder sendt af denne agent",
      "OUTGOING_EMAILS": "Antal udgående e-mails sendt af denne agent",
      "PHONE_CALLS": "Samlet antal telefonopkald tildelt denne agent (summen af indgående og udgående opkald)",
      "TOTAL_ACTIVITIES": "Samlet antal aktiviteter: indgående opkald + udgående opkald + udgående chats + udgående e-mails",
      "INBOUND_CALLS": "Antal indgående telefonopkald tildelt denne agent",
      "OUTBOUND_CALLS": "Antal udgående telefonopkald tildelt denne agent",
      "AVG_FIRST_RESPONSE_TIME": "Gennemsnitlig tid fra samtalen oprettes til agentens første svar i samtaler tildelt denne agent",
      "AVG_RESOLUTION_TIME": "Gennemsnitlig tid fra samtalen oprettes til den løses i samtaler tildelt denne agent",
      "AVG_REPLY_TIME": "Gennemsnitlig ventetid for kunder mellem deres besked og agentens svar i samtaler tildelt denne agent",
      "ONLINE_TIME": "Samlet tid, hvor agenten var online eller optaget i den valgte periode",
      "QUEUE_AVAILABLE_TIME": "Samlet tid, hvor agenten var tilgængelig i telefonkøer i den valgte periode"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefonrapporter",
    "DESCRIPTION": "Følg målinger for telefonopkald med detaljeret indsigt i indgående og udgående opkald, grupperet efter agent eller indbakke til en samlet analyse.",
    "DOWNLOAD_PHONE_REPORTS": "Download telefonrapporter",
    "GROUP_BY": {
      "LABEL": "Gruppér efter",
      "AGENT": "Agent",
      "INBOX": "Indbakke"
    },
    "TABLE": {
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Indgående",
      "OUTBOUND_CALLS": "Udgående",
      "FAILED_OUTBOUND_CALLS": "Mislykkede udgående",
      "AVG_AGENT_HANDLED_DURATION": "Gns. varighed",
      "TOTAL_AGENT_HANDLED_DURATION": "Samlet varighed",
      "AVG_RINGING_TIME": "Gns. ringetid",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Succes %",
      "UNIQUE_CALLERS": "Unikke opkaldere",
      "UNIQUE_CALLED_CONTACTS": "Unikke opkaldte",
      "UNANSWERED_MISSED_CALLS": "Ubesvaret uden opfølgning",
      "UNANSWERED_MISSED_PERCENTAGE": "Ubesvaret uden opfølgning %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Ubesvaret uden opfølgning, utilstrækkeligt ringet tilbage",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Ubesvaret uden opfølgning, utilstrækkeligt ringet tilbage %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Samlet antal opkald (inklusive ikke-forbundne)",
      "INBOUND_CALLS": "Antal forbundne opkald",
      "OUTBOUND_CALLS": "Antal alle udgående opkald (inklusive ikke-forbundne)",
      "FAILED_OUTBOUND_CALLS": "Antal udgående opkald, der ikke blev forbundet",
      "AVG_AGENT_HANDLED_DURATION": "Gennemsnitlig varighed af opkald håndteret af agenter",
      "TOTAL_AGENT_HANDLED_DURATION": "Samlet varighed af alle opkald håndteret af agenter",
      "AVG_RINGING_TIME": "Gennemsnitlig tid opkald ringede, før de blev besvaret",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Andel af udgående opkald, der blev forbundet",
      "UNIQUE_CALLERS": "Antal unikke kontakter, der foretog indgående opkald",
      "UNIQUE_CALLED_CONTACTS": "Antal unikke kontakter, der blev ringet op via udgående opkald",
      "UNANSWERED_MISSED_CALLS": "Antal ubesvarede opkald, hvor der ikke blev ringet succesfuldt tilbage (opkald forbundet). Kan omfatte opkald, der stadig kan håndteres inden for arbejdsdagen",
      "UNANSWERED_MISSED_PERCENTAGE": "Andel af unikke opkaldere, hvis opkald blev ubesvaret uden opfølgning (ubesvarede opkald uden opfølgning / unikke opkaldere)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Antal ubesvarede opkald med færre end 2 forsøg på at ringe tilbage. Kan omfatte opkald, der stadig kan håndteres inden for arbejdsdagen",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Andel af unikke opkaldere med færre end 2 forsøg på at ringe tilbage ((ubesvaret uden opfølgning - tilstrækkeligt håndteret) / unikke opkaldere)"
    }
  }
}
